import { cacheData } from "../_constants/Redux/CacheData";
import { getAllStates } from "../_services/Blockchain";

export const commonActions = {
    getSelectedValue,
};

function getSelectedValue(value, options) {
    if (value === null || value === "")
        return null

    let selectedvalue
    options && options.map((option, index) => {
        if (String(option.value) === String(value)) {
            selectedvalue = {
                label: option.label,
                value: option.value
            }
        }
        return true;
    })
    return selectedvalue
}

export function getStateDataFromApi(){
    return dispatch =>{
        // dispatch({ type: cacheData.FETCHING_GET_STATE_DATA})
        getAllStates().then(res=>{
            dispatch({ type: cacheData.GET_STATE_DATA, data:res})
        })
    }
}